<template>
  <div class="page h-screen flex flex-col">
    <div class="flex-1 flex flex-col justify-end overflow-auto">
      <FormPage 
        name="investor-classification"/>
    </div>
  </div>
</template>

<script>
import FormPage from "@/components/general/FormPage";
import form from "@/assets/ts/investor_type/base";
import companyForm from "@/assets/ts/investor_type/company";
import { defineComponent } from "vue";
import store from "@/store";

export default defineComponent({
  components: {
    FormPage
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      store.dispatch('setForm', store.getters.getProfile().type === 'particular' ? form : companyForm)
    });
  },

  setup(){
  }
})

</script>
